(ns frontend.ux-overhaul.listing.generic.toolbar
  "Helpers that the controls of the toolbar of a listing share: the label of a field, the
   form of a field path, and the closing of a popup with the Escape key."
  (:require
   [ui.dom-globals :as dg]))

(defn field-label
  "The text of a field in a list: its label, or its name, or its path."
  [field]
  (or (:label field)
      (:field/name field)
      (:field/label field)
      (some-> (:field-path field) pr-str)))

(defn field-path-normalized
  "A field path as a vector, or nil when it is not a path."
  [field-path]
  (cond
    (vector? field-path) field-path
    (keyword? field-path) [field-path]
    (sequential? field-path) (vec field-path)
    :else nil))

(defn field-path-key
  [field-path]
  (pr-str (field-path-normalized field-path)))

(defn close-on-escape-handler
  "A key handler that closes the popup when the Escape key is pressed. `open?*` is the atom
   that says if the popup is open."
  [open?*]
  (fn [event]
    (when @open?*
      (dg/escape-key-handler event
                             (fn []
                               (reset! open?* false))))))
